// Navigation the app performs on its own behalf, such as swapping "/" for the URL of the project it
// just created. Transient UI that dismisses itself when the visitor navigates must ignore these.
export const appRedirectState = { appRedirect: true };

export function isAppRedirect(state: unknown) {
  return Boolean((state as { appRedirect?: boolean } | null)?.appRedirect);
}

export function setupUrlAfterAuth(url: URL) {
  if (url.pathname === '/') return null;
  if (url.pathname === '/practice') {
    const source = url.searchParams;
    const setup = new URLSearchParams();
    for (const key of ['sessionId', 'role', 'interviewType', 'difficulty', 'contextIds']) {
      const value = source.get(key);
      if (value) setup.set(key, value);
    }
    return `/${setup.size ? `?${setup}` : ''}`;
  }
  const sessionMatch = url.pathname.match(/^\/sessions\/([^/]+)$/);
  if (sessionMatch) return `/sessions/${encodeURIComponent(sessionMatch[1])}`;
  const projectMatch = url.pathname.match(/^\/projects\/([^/]+)$/);
  if (projectMatch) return `/projects/${encodeURIComponent(projectMatch[1])}${url.search}`;
  return '/';
}
